
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class BranchStructureService {
    private API1 = 'api/v1/masters/flatorg/';
    constructor(private http: HttpClient) { }

    saveOrEditOrgFlat(orgFlatMasterCompositeDTO: any,flatOrgUid,branchCode,chain) {
        if (flatOrgUid && flatOrgUid != 0) {
            return this.http.put<any>(this.API1 + flatOrgUid + '/' + branchCode + '/' + chain + '/save', orgFlatMasterCompositeDTO, { observe: 'response' });
        } else {
            return this.http.post<any>(this.API1 + 0 + '/' + branchCode + '/' + chain + '/save', orgFlatMasterCompositeDTO, { observe: 'response' });
        }
    }
}